import styled from "styled-components";
import { DesignTokens } from "melco-ui";

const { colors, spacings } = DesignTokens;

export const EmptyWrapper = styled.div`
  border: 1px dashed ${colors.gray.middle};
  padding: ${spacings.middle}px;
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
